import {Component, Vue} from 'vue-property-decorator';
import {applicationStore} from '@/store/modules/application';

@Component({name: 'Navigation'})
export default class Navigation extends Vue {
    protected selectPage(index: number) {
        applicationStore.selectPage(index);
    }
}
